/**
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/** The current API version of the generated client. */
const API_VERSION = '10.10.0';
/** The minimum supported server version. */
const MINIMUM_VERSION = '10.9.0';

export { API_VERSION, MINIMUM_VERSION };
